export const deployConstants = {
  lastDeployTimestamp: 'lastDeployTimestamp',
  clearDeployTimestamp: 'clearDeployTimestamp',
};
